
import React, { useState, useEffect, Fragment } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import useMobileScreen from "../useMobileScreen";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

const getPropertyName = (property, lang, preview = false) => {
    const translation = property.propertyTranslations?.find(t => t.languageIsoCode === lang);
    if (preview) {
        const limit = 15;
        const name = translation ? translation.propertyName : property.name;
        return name?.length > limit ? name?.slice(0, limit) + "..." : name;
    }
    return translation ? translation.propertyName : property.name;
};

const getCityName = (city, lang) => {
    const translation = city.translations?.find(t => t.languageIsoCode === lang);
    return translation ? translation.cityName : city.internationalName;
};

const getBrandName = (brand, lang, preview = false) => {
    const translation = brand?.translations?.find(t => t.languageIsoCode === lang);
    if (preview) {
        const limit = 10;
        const name = translation ? translation?.brandName : brand?.brandName;
        return name?.length > limit ? name?.slice(0, limit) + "..." : name;
    }
    return translation ? translation?.brandName : brand?.brandName;
};

const MobilePropertyBrandFilter = ({brands, properties, cities, propertiesFiltered, lang, selectedBrand, selectedBrandName, selectedProperty, currentChainBrand,setPropertiesFiltered,setSelectedBrand,setSelectedCategory,setSelectedProperty,products,setSelectedBrandName}) => {
    const { t } = useTranslation();
    const isMobile = useMobileScreen();
    const [showCityLabel, setShowCityLabel] = useState(true);

    const selectBrandHandler = (brand) => {
        selectPropertyHandler();
        setSelectedCategory("category-all");

        let selectedBrand = brand ? `brand-${brand.brandId}` : null
        setSelectedBrand(selectedBrand);
        setSelectedBrandName( brand?.brandName );
        if (brand) {
            const brandProperties = properties.filter(p => p.brandId === brand.brandId);
            setPropertiesFiltered(brandProperties);
        } else {
            setPropertiesFiltered(getPropertiesByProducts());
        }
    }

    const selectPropertyHandler = (property) => {
        setSelectedProperty(property ? `property-${property.propertyId}` : "property-all");
    };

    const getPropertiesByCity = (city) => {
        return propertiesFiltered.filter(p => p.cityId === city.cityId);
    };

    const getPropertiesByProducts = () => {
        let propertiesFiltered = [];
        properties.forEach(property => {
            if (products.some(product => product.propertyId === property.propertyId || product.propertyId == -1)) {
                propertiesFiltered.push(property);
            }
        });
        return propertiesFiltered;
    }

    const getProperty = (selectedProperty) =>{
        let selectedId = selectedProperty?.toString().replace("property-", "");
        return properties.find(pr => pr.propertyId == selectedId)
    };

    return (
          
            <div className="filter-section">
                <DropdownButton
                    id="hotel-filter"
                    className="custom-dropdown"
                    title={
                        (selectedBrand && !selectedProperty)
                            ? `${t("Hotels")} ${selectedBrandName}`
                            : selectedProperty && selectedProperty !== "property-all"
                                ? getPropertyName(getProperty(selectedProperty), lang, true)
                                : t("AllProperties")}
                >
                    {isMobile && !!brands.length && (
                        <div className="mobile-brands">
                            <Dropdown.Item as="button" className={!selectedBrand ? 'active' : ''} aria-label={t("AllProperties")} value={null} onClick={e => selectBrandHandler(null)}>
                                <img src={currentChainBrand?.brandLogoUrl} /><span>{t("AllProperties")}</span>
                            </Dropdown.Item>
                            {brands.map((brand, index) =>
                                brand.brandId !== currentChainBrand?.brandId && (
                                    <Dropdown.Item as="button" className={selectedBrand && selectedBrand == `brand-${brand.brandId}` ? 'active' : ''} aria-label={getBrandName(brand, lang)} value={brand.productCategoryId} onClick={e => selectBrandHandler(brand)} key={index}>
                                        <img src={brand.brandLogoUrl} /><span>{brand.brandName}</span>
                                    </Dropdown.Item>
                                ))}
                        </div>
                    )}
                    {
                        !brands.length && !isMobile &&
                        <Dropdown.Item as="button" className="custom-button" aria-label={t("AllProperties")} value={""} onClick={e => selectPropertyHandler()} key={""}>
                            {t("AllProperties")}
                        </Dropdown.Item>
                    }
                    {cities.map((c, i) => {
                        const cityProperties = getPropertiesByCity(c);
                        return cityProperties.length > 0 && (
                            <Fragment key={i}>
                                {showCityLabel && <Dropdown.Item as="h5" aria-readonly eventKey={i} aria-label={getCityName(c, lang)}>{getCityName(c, lang)}</Dropdown.Item>}
                                {cityProperties.map((p, i) => (
                                    <Dropdown.Item key={i} as="button" className="custom-button" aria-label={getPropertyName(p, lang)} value={p.propertyId} onClick={e => selectPropertyHandler(p)}>
                                        {getPropertyName(p, lang)}
                                    </Dropdown.Item>
                                ))}
                            </Fragment>
                        );
                    })}
                </DropdownButton>
            </div>
    )
}

export default MobilePropertyBrandFilter;